module.exports = __webpack_public_path__ + "static/Glovo-9ae701d93e565aa807631685b6a4ed91.jpg";